import React, { useState } from 'react';
import { Modal, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ENGRAVING, ANNEALING } from '@/constants';
import { Button, Icon } from '@/components';
import RadioIcon from '@/icons/icon-radio.svg';
import RadioActiveIcon from '@/icons/icon-radio-active.svg';
import { ModalWrapperStyled, ModalHeaderStyled, ModalBodyStyled, RowStyled, OptionTitleStyled, DescriptionStyled, ModalFooterStyled } from './styles';

const LaserOutputQualityModal = props => {
  const { handleSetLaserOutputQuality, handleLaserOutputQualityModalOpen } = props;
  const laserOutputQuality = useSelector((state) => state.core.laserOutputQuality);
  const [mode, setMode] = useState(laserOutputQuality);
  const disabled = !mode;

  const handleLaserModeOutputQualityChange = mode => {
    setMode(mode);
  };

  const handleApply = () => {
    handleSetLaserOutputQuality(mode);
    handleLaserOutputQualityModalOpen(false);
  }

  return (
    <Modal open>
      <ModalWrapperStyled>
        <ModalHeaderStyled>
          <FormattedMessage id="cmme.laserOutputQualitySelection" defaultMessage="Please, select Laser output quality" />
        </ModalHeaderStyled>
        <ModalBodyStyled>
          <RowStyled sx={{ marginBottom: '10px', cursor: 'pointer' }} onClick={handleLaserModeOutputQualityChange.bind(null, ENGRAVING)}>
            <Box display="flex">
              <Icon src={mode === ENGRAVING ? RadioActiveIcon : RadioIcon} />
            </Box>
            <OptionTitleStyled>
              <FormattedMessage id="cmme.laserOutputQuality.engraving" defaultMessage="Engraving" />
            </OptionTitleStyled>
          </RowStyled>
          <RowStyled mb="25px">
            <div />
            <DescriptionStyled>
              <FormattedMessage id="cmme.laserOutputQuality.engraving.description" />
            </DescriptionStyled>
          </RowStyled>
          <RowStyled sx={{ marginBottom: '10px', cursor: 'pointer' }} onClick={handleLaserModeOutputQualityChange.bind(null, ANNEALING)}>
            <Box display="flex">
              <Icon src={mode === ANNEALING ? RadioActiveIcon : RadioIcon} />
            </Box>
            <OptionTitleStyled>
              <FormattedMessage id="cmme.laserOutputQuality.annealing" defaultMessage="Annealing" />
            </OptionTitleStyled>
          </RowStyled>
          <RowStyled mb="50px">
            <div />
            <DescriptionStyled>
              <FormattedMessage id="cmme.laserOutputQuality.annealing.description" />
            </DescriptionStyled>
          </RowStyled>
        </ModalBodyStyled>
        <ModalFooterStyled>
          <Button variant="secondary" disabled={disabled} onClick={handleApply}>
            <FormattedMessage id="app.footer.button.apply" defaultMessage="Apply" />
          </Button>
        </ModalFooterStyled>
      </ModalWrapperStyled>
    </Modal>
  );
};

export default LaserOutputQualityModal;
